/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import InfluenceCass from 'solis/logic/board/influence/cass';
import ZoneUsers from 'solis/logic/board/zone/users';

import * as Array from 'fierry/util/array';


export default class ZoneInfluences extends Logic
{
  destroyInfluence (sourceColony)
  {
    const influence = this.object.getInfluence(sourceColony);

    if (influence !== null)
    {
      this.object.getBoard().unloadInfluence(influence.cass);
    }
  }


  destroyUserInfluences (user)
  {
    for (const influence of this.object.getInfluencesForUser(user))
    {
      this.object.getBoard().unloadInfluence(influence.cass);
    }
  }


  establishEnemyInfluences ()
  {
    for (const influence of this.getEnemyInfluences())
    {
      new InfluenceCass(influence).establish();
    }
  }


  resetEnemyInfluences (now)
  {
    for (const influence of this.getEnemyInfluences())
    {
      new InfluenceCass(influence).resetDuration(now);
    }
  }


  getEnemyInfluenceValue ()
  {
    return Array.sum(this.getEnemyInfluences(), (influence) => influence.cass.value);
  }


  getSurrenderCurrency ()
  {
    return new ZoneUsers(this.object).isOriginOccupied() ? 0 : this.getEnemyInfluenceValue();
  }


  getUserInfluenceValue (user)
  {
    return Array.sum(this.object.getInfluencesForUser(user), (influence) => influence.cass.value);
  }


  getEnemyInfluences ()
  {
    const isEnemy = (influence) =>
    {
      return influence.getSourceUserID() !== new ZoneUsers(this.object).getColonyUser();
    };

    return this.object.getInfluences().values().filter(isEnemy);
  }


  getChallengerInfluences ()
  {
    const users = new ZoneUsers(this.object);

    return this.object.getInfluences().values().filter(influence => !users.isCurrentUser(influence.getSourceUserID()));
  }


};
